import React from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import ChartGallery from "./App"

createRoot(document.getElementById("root")).render(<ChartGallery />)
